import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//kehu
export async function getDictForAmountDivide(params) {
    return post(oaserver+'/payment/excel/getDictForAmountDivide', params, true);
}
//yu e
export async function getAmountForDivide(params) {
    return post(oaserver+'/payment/excel/getAmountForDivide', params, true);
}
//baocun
export async function saveAmountDivided(params) {
    return post(oaserver+'/payment/excel/saveAmountDivided', params, true);
}
//fukuanshenqingliebiao
export async function getPaymentApplies(params) {
    return post(oaserver+'/payment/excel/getPaymentApplies', params, true);
}

//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//汇率
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
